




























































































import { Vue, Component } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import { Tip } from "@/common/interface";
import { majorNoticeText } from '@/common/constants/index';

import getUrlParam from '@/common/utils/getUrlParam';
import throttle from '@/common/utils/throttle';
import { setObserver } from '@/common/utils/setObserver';

import Tips from "@/components/common/index/Tips.vue";
import DashLine from "@/components/common/edit/DashLine.vue";
import ActivitySwitch from "@/components/common/edit/ActivitySwitch.vue";
import PotentialSwitch from '@/components/common/edit/PotentialSwitch.vue';


const solitaireTips = {
  title: "接龙支付功能说明",
  content: `
        <p>1、使用线上支付会收取<span style="color: #FF6152">0.63%</span>的服务费</p>
        <p>2、活动发布后，不可更改支付模式，不可修改定金金额</p>
        <p>3、支付模式</p>
        <p>家长按定金金额支付，再通过线下补齐最终接龙价差额（定金金额需低于最终接龙价）</p>
        <p>4、家长支付的金额，可在【小麦秀钱包】中查看和提现</p>
      `
};

interface Payload {
  status?: boolean;
  number?: number;
}

@Component({
  components: {
    "activity-switch": ActivitySwitch,
    "dash-line": DashLine,
    "potential-swtich": PotentialSwitch,
    tips: Tips
  }
})
export default class PayEdit extends Vue {
  @Getter("canPay") canPay!: boolean;
  @Getter("payType") payType!: number;
  @Getter("limitNum") limitNum!: number;
  @Getter('leftQuota') leftQuota!: number;
  @Getter("payNumber") getterPayNumber!: number;
  @Getter("section") section!: object;
  @Getter("mainTextColor") mainTextColor!: object;
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("xmMajordomo") xmMajordomo!: boolean;
  @Getter("virtualGroup") virtualGroup!: boolean;
  @Getter('showPayEditModal') showPayEditModal!: boolean
  @Getter("xcxType") xcxType!: string;

  @Action("switchCanPay") switchCanPay!: Function;
  @Action("switchMustMinPay") switchMustMinPay!: Function;
  @Action("changePayType") changePayType!: Function;
  @Action("changePayNumber") changePayNumber!: Function;
  @Action("changeGroupSwitch") changeGroupSwitch!: Function;
  @Action("changeLimitNumber") changeLimitNumber!: Function;
  @Action("changeLeftQuota") changeLeftQuota!: Function;
  @Action("changePayEditModal") changePayEditModal!: Function;

  type: string = getUrlParam("type") as string;
  solitaireTips: Tip = solitaireTips;
  hasPreview: boolean = false;
  getUrlParam: Function = getUrlParam;
  throttle: Function = throttle;
  timer:any = null;

  hasChangeSwitch: boolean = false;

  mounted() {
    this.handleShowPayEditTootips();
  }

  get payNumber(): number {
    return this.getterPayNumber;
  }

  set payNumber(val: number) {
    const payload: Payload = {
      number: val
    };
    this.changePayNumber(payload);
  }

  get limitNumber(): number {
    return this.limitNum;
  }
  set limitNumber(val: number) {
    const payload: Payload = {  number: val };
    this.changeLimitNumber(payload);
    this.changeLeftQuota(val);
  }
  handlePaySwitch(status: boolean): void {
     if (this.xcxType === "mkb") {
      return;
    }
    // 小程序制作的活动不支持支付
    if (this.xcxFlag) {
      Vue.$confirm({
        oneBtn: true,
        title: "提示",
        text: majorNoticeText,
        okText: "确定"
      });
      return;
    }
    if (this.type === "edit") {
      const payload: Payload = { status };
      this.switchCanPay(payload);
    }
  }
  handleGroupSwitch(status: boolean): void {
    if (getUrlParam("adminId")) {
      return;
    }
    if (this.type !== "reEdit") {
      this.changeGroupSwitch(status);
    } else {
      Vue.$toast.error("发布活动后不可修改开启限制");
    }
  }


  handleChangePayType(item: any): void {
    if (item.value !== this.payType && this.type === "edit") {
      this.changePayType({ payType: item.value });
    }
  }

  handleShowPayEditTootips() {
    const id = getUrlParam('id');
    if (getUrlParam('type') === 'edit' && !window.localStorage.getItem(`template${id}`)) {
      window.localStorage.setItem(`template${id}`, 'true');
      const paySwitchContentDom = document.querySelector('.pay-switch-content') as HTMLDivElement;
      (paySwitchContentDom as any).io = setObserver('changePayEditModal', true);
      (paySwitchContentDom as any).io.observe(paySwitchContentDom);
      
    }
  }

  beforeDestroy() {
    window.clearTimeout(this.timer)
  }
}
